import {useTranslate} from '@tolgee/react'
import {Box, DialogBody, DialogHeader, Tabs, Text} from '@chakra-ui/react'
import {DoseReductionTabsList} from './tabs-list'
import {GlobalDoseReductionTab} from './global-tab'
import {IndividualDoseReductionTab} from './individual-tab'
import {DrugItem} from './types'

interface AddDoseReductionDialogProps {
  patientId: string
  drugItems?: DrugItem[]
}

export function AddDoseReductionDialog({patientId, drugItems}: AddDoseReductionDialogProps) {
  const {t} = useTranslate('dose-reduction')
  return (
    <>
      <DialogHeader>
        <Box display={'flex'} flexDirection={'column'} gap="1">
          <Text fontWeight={'semibold'} fontSize={'lg'}>
            {t('title')}
          </Text>
          <Text fontWeight={'normal'} fontSize={'md'} color="fg.muted">
            {t('description')}
          </Text>
        </Box>
      </DialogHeader>

      <DialogBody minHeight={'none'} maxWidth={'100%'} paddingBottom={'2'}>
        <Tabs.Root defaultValue={'global'} spaceY="5" variant={'enclosed'}>
          <DoseReductionTabsList />
          <Tabs.Content value="global" paddingY="4">
            <GlobalDoseReductionTab patientId={patientId} />
          </Tabs.Content>
          <Tabs.Content value="individual" paddingY="4">
            <IndividualDoseReductionTab patientId={patientId} drugItems={drugItems ?? []} />
          </Tabs.Content>
        </Tabs.Root>
      </DialogBody>
    </>
  )
}
